// AvisoWhatsapp.jsx · el aviso de WhatsApp de #1683 v2 (D3 v2, R58, R59, R65). Mockup elegido: variante B,
// "caja suave con ícono de WhatsApp" (tools/mockups/smartdx_mockups_1683_derechos_v2.html).
//
// Por qué existe: con D3 v2 el permiso de WhatsApp nace al aceptar los Términos (no hay casilla),
// así que lo único que la persona ve en ese momento es este aviso: qué (WhatsApp desde SmartDx),
// para qué (primeros pasos y recordatorios) y cómo salir (interruptor de la Cuenta, link de los
// correos, responder BAJA). Los textos viven acá, juntos, para que un cambio de redacción se haga en
// UN lugar y el test (`AvisoWhatsapp.test.jsx`) los vigile. El del gate de Términos empieza con
// "Si no te has dado de baja" para seguir siendo verdadero en quien ya se dio de baja (R65).
// Todo color por tokens de theme.js (R61), nada de hex. Texto de 12.5 px como el mockup.
// Cubre R58, R59, R65, R61 — .claude/specs/1683-derechos-usuario/
import React from "react";
import { Box, Typography } from "@mui/material";

export const SALIDA = (
  <>
    Para dejar de recibirlos: el interruptor en tu <b>Cuenta</b>, el link de nuestros correos o responde{" "}
    <b>BAJA</b>.
  </>
);

// Texto por lugar. `registro` sirve al registro con correo y a la cuenta nueva con Google (mismo aviso).
export const TEXTOS = {
  registro:
    "Al aceptar, SmartDx también podrá escribirte por WhatsApp, desde su número, para ayudarte a usar la app: primeros pasos y recordatorios.",
  celular:
    "Usaremos este número para escribirte por WhatsApp desde SmartDx y ayudarte a usar la app: primeros pasos y recordatorios.",
  terminos:
    "Si no te has dado de baja, SmartDx puede escribirte por WhatsApp para ayudarte a usar la app.",
};

const BurbujaIcono = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"
    style={{ stroke: "currentColor", fill: "none", strokeWidth: 1.9, strokeLinecap: "round", strokeLinejoin: "round" }}>
    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
  </svg>
);

const AvisoWhatsapp = ({ testid, lugar = "registro", sx }) => (
  <Box
    data-testid={testid}
    sx={{
      display: "flex", gap: "10px", mt: "10px", p: "11px 13px", borderRadius: "12px", textAlign: "left",
      backgroundColor: "rgba(var(--color-success-rgb),0.08)",
      border: "1px solid rgba(var(--color-success-rgb),0.3)",
      ...sx,
    }}
  >
    <Box
      aria-hidden="true"
      sx={{
        width: 28, height: 28, borderRadius: "8px", flex: "none", display: "grid", placeItems: "center",
        backgroundColor: "rgba(var(--color-success-rgb),0.16)", color: "var(--color-success)",
      }}
    >
      <BurbujaIcono />
    </Box>
    <Typography
      component="p"
      sx={{
        fontSize: 12.5, lineHeight: 1.5, color: "var(--text-tertiary)", m: 0, minWidth: 0,
        "& b": { color: "var(--text-primary)" },
      }}
    >
      {TEXTOS[lugar] || TEXTOS.registro} {SALIDA}
    </Typography>
  </Box>
);

export default AvisoWhatsapp;
